export function checkData2DFid(data) {
    if (!('re' in data && 'im' in data)) {
        throw new Error('imaginary (im) data should exists');
    }
}
//# sourceMappingURL=checkData2DFid.js.map